import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Pages } from '../../../common/src/pages.ts';
import { getUrlForPage } from '../util/path.ts';
import { shareWithMusicLeader } from './onboarding/common.tsx';

export function ChurchRequired() {
  return (
    <ChurchRequiredWrapper>
      To use this tab, select a church in household <Link to={getUrlForPage(Pages.Household)}>settings</Link> or{' '}
      <AskYourMusicLeader /> to add your church to the app. If you are the music leader,{' '}
      <Link to="https://calendar.app.google/gnnXn7zGBiB1fN469">click here</Link> to talk about getting your church
      setup.
    </ChurchRequiredWrapper>
  );
}

const ChurchRequiredWrapper = styled.div`
  color: var(--color-text);
`;

export function AskYourMusicLeader() {
  return (
    <div className="inlineLink" onClick={shareWithMusicLeader}>
      ask your music leader
    </div>
  );
}
